import { IFaceted } from '../models/Facet';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { IDispatch } from '../store/actions/createActionCreator';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';

/**
 * The properties to pass to the callout containing the sharing dialog
 * @public
 */
export interface ISharingWizardProps extends IWithWizardInjectedProps {
  getSharingInformation: () => Promise<ISharingInformation>;
  getClientId: () => string;
  itemKey: string;
  mode: 1 | 2; // 1 for sharing mode, 2 for copy link mode
}

/**
 * @public
 */
export interface ISharingInformation {
  /**
   * If using token based authentication, authToken,
   * webAbsoluteUrl, listUrl, and serverRelativeItemUrl
   * are all required. listUrl and serverRelativeItemUrl
   * together identify the item.
   */
  authToken?: string;
  webAbsoluteUrl?: string;
  listUrl?: string;
  serverRelativeItemUrl?: string;
  /**
   * If using cookie based authentication, only
   * cookieAuthIframeUrl is required.
   */
  cookieAuthIframeUrl?: string;
}

/**
 * @public
 */
export const shareActionControl = new ControlFacet<{
  itemKey: string;
}, {
    isAvailable: boolean;
    getSharingInformation: () => IItemCacheThunkAction<Promise<ISharingInformation>>;
  }>('shareActionControl');

// @ts-ignore
type __unused_declarations = Pick<
  IFaceted |
  IDispatch<never> |
  IItemCacheState,
  never>;
